module.exports = __webpack_public_path__ + "static/apple_store_badge-5474951deb26f8e0f364f14017394d84.svg";